import React from 'react';
import c from 'classnames';
import s from './InputLabelSubText.scss';
var InputLabelSubText = function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement("div", { className: c(s['root'], className) }, children);
};
InputLabelSubText.displayName = 'InputLabelSubText';
export default InputLabelSubText;
//# sourceMappingURL=InputLabelSubText.js.map